import React, { useState, useRef, useEffect } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

import Porto from '../../assets/images/parceiros/Porto.png';
import Bradesco from '../../assets/images/parceiros/Bradesco.png';
import Mapfre from '../../assets/images/parceiros/Mapfre.png';
import HDI from '../../assets/images/parceiros/HDI.png';
import Sancor from '../../assets/images/parceiros/Sancor.png';
import Azul from '../../assets/images/parceiros/Azul.png';
import Liberty from '../../assets/images/parceiros/Liberty.png';
import Zurich from '../../assets/images/parceiros/Zurich.png';
import Itau from '../../assets/images/parceiros/Itau.png';
import Aliro from '../../assets/images/parceiros/Aliro.png';
import Tokio from '../../assets/images/parceiros/Tokio.png';
import Sulamerica from '../../assets/images/parceiros/Sulamerica.png';
import Sura from '../../assets/images/parceiros/Sura.png';
import Mitsui from '../../assets/images/parceiros/Mitsui.png';
import Sompo from '../../assets/images/parceiros/Sompo.png';
import Ezze from '../../assets/images/parceiros/Ezze.png';

// Hook embutido
function useOnScreen(ref, threshold = 0.1) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, threshold]);

  return isIntersecting;
}

const partners = [
  { src: Porto, alt: 'Porto' },
  { src: Bradesco, alt: 'Bradesco' },
  { src: Mapfre, alt: 'Mapfre' },
  { src: HDI, alt: 'HDI' },
  { src: Sancor, alt: 'Sancor' },
  { src: Azul, alt: 'Azul' },
  { src: Liberty, alt: 'Liberty' },
  { src: Zurich, alt: 'Zurich' },
  { src: Itau, alt: 'Itau' },
  { src: Aliro, alt: 'Aliro' },
  { src: Tokio, alt: 'Tokio' },
  { src: Sulamerica, alt: 'Sulamerica' },
  { src: Sura, alt: 'Sura' },
  { src: Mitsui, alt: 'Mitsui' },
  { src: Sompo, alt: 'Sompo' },
  { src: Ezze, alt: 'Ezze' },
];

const PartnersSection = () => {
  const sectionRef = useRef();
  const isVisible = useOnScreen(sectionRef);

  const Autoplay = (slider) => {
    let timeout;
    let mouseOver = false;

    const clearNextTimeout = () => clearTimeout(timeout);
    const nextTimeout = () => {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => {
        slider.next();
      }, 1200);
    };

    slider.on('created', () => {
      slider.container.addEventListener('mouseover', () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider.container.addEventListener('mouseout', () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });

    slider.on('dragStarted', clearNextTimeout);
    slider.on('animationEnded', nextTimeout);
    slider.on('updated', nextTimeout);
  };

const [sliderRef] = useKeenSlider(
  {
    loop: true,
    mode: 'free-snap',
    slides: { perView: 5, spacing: 16 },
    breakpoints: {
      '(min-width: 640px)': { slides: { perView: 5, spacing: 16 } },
      '(min-width: 768px)': { slides: { perView: 6, spacing: 22 } },
      '(min-width: 1024px)': { slides: { perView: 8, spacing: 8 } },
    },
    renderMode: 'performance',
    drag: true,
  },
  [Autoplay]
);

  return (
    <section
      ref={sectionRef}
      className={`py-16 bg-gray-50 transition-opacity duration-1000 transform ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
      }`}
    >
      <div className="container mx-auto px-4">
        <h2 className="text-3xl sm:text-4xl text-center font-bold text-blue-950 mb-12">
          Nossas Seguradoras Parceiras
        </h2>
        <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-blue-800 scrollbar-track-gray-200">
          <div ref={sliderRef} className="keen-slider">
            {partners.map((partner, idx) => (
              <div
                key={idx}
                className="keen-slider__slide flex justify-center items-center"
              >
                <img
                  src={partner.src}
                  alt={partner.alt}
                  className="h-12 md:h-16 object-contain grayscale hover:grayscale-0 transition duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;